<div ngbDropdown
     class="d-inline-block m-0">
  <button class="btn btn-outline-secondary rounded-pill border-0"
          id="dropdownHistory"
          ngbTooltip="Vedi Storico"
          [disabled]="!history || history.length < 1"
          ngbDropdownToggle>
    <fa-icon aria-hidden="true"
             [icon]="icons.faArrowLeft"></fa-icon>
  </button>
  <div ngbDropdownMenu
       aria-labelledby="dropdownHistory">
    <button *ngFor="let item of history; let i = index;"
            (click)="onSelectedObject(item, i)"
            ngbDropdownItem>{{item.alias}} - {{item.label}}</button>
  </div>
</div>